<template>
  <div class="message-item">
    <div class="message-item-top">
      <div class="message-item-top-left">
        <!-- 通知分类icon,本地图片对应写死,0表示系统通知图标；1：故障通知图标、2：告警通知图标、3：离线通知图标、4：维护通知息图标 -->
        <!-- 系统消息图标 -->
        <Icon type="message_system" v-if="currentCategory?.type === 0" class="icon" />
        <!-- <Icon type="msg_charger" class="icon" v-else /> -->
        <DeviceAvatar :avatarType="msg.avatar || msg.dev.avatar" v-else />
        <div class="content">
          <h4>
            <!-- 设备 -->
            <router-link
              :to="{
                name: 'DeviceDetail',
                params: { id: msg.devId || msg.dev.devId },
              }"
              v-if="
                ([1, 2, 3, 4].includes(currentCategory?.type) &&
                  authList.includes('auth_device_detail')) ||
                  isSuperAdmin
              "
            >
              <i
                v-for="(part, index) in highlightKeyword(msg.title, keyword)"
                :key="index"
                :class="part.isKeyword ? 'highlight' : ''"
                >{{ part.text }}</i
              >
            </router-link>

            <a
              :href="msg.url"
              @click.prevent="
                e => {
                  handleUrl(msg);
                  e.preventDefault();
                }
              "
              target="_blank"
              v-else-if="msg.url"
            >
              <!-- {{ msg.title }} -->
              <i
                v-for="(part, index) in highlightKeyword(msg.title, keyword)"
                :key="index"
                :class="part.isKeyword ? 'highlight' : ''"
                >{{ part.text }}</i
              >
            </a>
            <span v-else
              ><i
                v-for="(part, index) in highlightKeyword(msg.title, keyword)"
                :key="index"
                :class="part.isKeyword ? 'highlight' : ''"
                >{{ part.text }}</i
              >
            </span>
          </h4>
          <p>{{ msg.createTime | formatDate }}</p>
        </div>
      </div>
      <div class="message-item-top-right">
        <!-- 消息已处理 -->
        <a-button v-if="msg.handle && currentCategory?.type === 4" class="btn" disabled>
          <a-icon type="check" />{{ $t('message_processed') }}
        </a-button>

        <!-- 处理未处理 -->
        <a-button
          v-if="!msg.handle && currentCategory?.type === 4 && AUTH_MESSAGE_HANDLE_ONE"
          class="btn danger"
          type="danger"
          @click="handleOne(msg)"
        >
          <a-icon type="close" />{{ $t('message_untreated') }}
        </a-button>

        <!-- 恢复/未恢复 -->
        <a-button
          v-if="[1, 2, 3].includes(currentCategory?.type) && msg.handle"
          class="btn"
          disabled
        >
          <a-icon type="check" />{{ $t('message_recovered') }}
        </a-button>
        <a-button
          v-if="[1, 2, 3].includes(currentCategory?.type) && !msg.handle"
          class="btn danger"
          type="danger"
        >
          <a-icon type="close" />{{ $t('message_unrecovered') }}
        </a-button>
      </div>
    </div>
    <div class="message-item-content">
      <div v-html="sanitizedHtml" class="g-html-content"></div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/message';
import messageAuth from '@/views/message/mixins/messageAuth';
import DOMPurify from 'dompurify';
import { mapGetters } from 'vuex';

export default {
  mixins: [messageAuth],
  props: {
    msg: Object,
    currentCategory: Object,
    callback: Function,
    keyword: String,
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),

    sanitizedHtml() {
      // 使用 DOMPurify 清理 HTML
      let cleanHtml = DOMPurify.sanitize(this.msg.content, {
        ALLOWED_ATTR: ['class', 'id', 'style', 'href'], // 指定允许保留的属性
      });

      if (this.keyword) {
        // 构建正则表达式
        let regex = new RegExp(this.keyword, 'g');

        // 给关键字加上颜色
        cleanHtml = cleanHtml.replace(regex, '<mark>$&</mark>');
      }

      return cleanHtml;
    },
  },
  methods: {
    // 高亮搜索关键字
    highlightKeyword(text, keyword) {
      if (!keyword) {
        return [
          {
            text: text,
            isKeyword: false,
          },
        ];
      }
      const regex = new RegExp(`(${keyword})`, 'gi'); // 匹配关键字，忽略大小写
      const parts = text.split(regex); // 分割文本
      const newParts = [];
      parts.forEach(part => {
        const _part = {
          text: part,
          isKeyword: regex.test(part),
        };
        newParts.push(_part);
      });
      return newParts;
    },

    // 单个处理
    handleOne(msg) {
      this.$confirm({
        title: this.$t('message_confirm_handle_one_content'),
        content: this.$t('device_confirm_maintain_content2'),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('message_handle_loading'));
          const params = {
            messageId: msg.id,
            categoryId: msg.categoryId,
            devId: msg.devId || msg.dev.devId,
          };

          API.handleMtone(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));

                // 回调
                this.callback && this.callback();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 跳转
    handleUrl(item) {
      this.$confirm({
        title: this.$t('message_url_redirect'),
        content: item.url,
        centered: true,
        onOk: () => {
          window.open(item.url, '_blank');
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.message-item {
  font-size: 14px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  flex: 1;

  // header
  .message-item-top {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;

    .message-item-top-left {
      display: flex;
      justify-content: left;
      align-items: center;

      .icon {
        width: 32px;
        height: 32px;
        font-size: 32px;
        margin-right: 20px;
        color: #999;
      }

      .content {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;

        h4 {
          color: rgba(0, 0, 0, 0.88);
          font-size: 18px;
          font-weight: 600;
          margin: 0;
          padding: 7px 0 5px;
        }

        p {
          color: #71717a;
          font-size: 14px;
          font-weight: 400;
          margin: 0;
        }

        i {
          font-style: normal;
        }
      }
    }

    .message-item-top-right {
      .btn {
        font-size: 14px;
        line-height: 24px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.25);

        &.danger {
          background: #f5222d;
          border: 1px solid #f5222d;
          box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
          color: #fff;
        }
      }
    }
  }

  // content
  .message-item-content {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    padding: 20px 24px;
    color: #18181a;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
}

.highlight {
  color: #f00 !important;
  font-weight: bold !important;
}
</style>
